import { authRequest } from './api/auth';

/**
 * 伺服器授權狀態。整台伺服器一份，不分租戶。
 *
 * 回傳 { status_code, expiry_date, stop_date }：
 *   status_code — VALID / EXPIRING_SOON / EXPIRED_GRACE / SUSPENDED / INVALID
 *   expiry_date — 訂閱到期日（ISO8601 UTC 字串）；INVALID 時為 null
 *   stop_date   — 服務停止日（ISO8601 UTC 字串）；INVALID 時為 null
 *
 * stop_date 由後端算好回傳，前端不得自行推算——寬限期天數不應明碼出現在客戶端。
 * 訊息組裝與語系選擇全部在前端，後端只給狀態碼與兩個日期。
 */
class LicenseService {
    getStatus() {
        return authRequest.get(`/license/status/`);
    }
}

export default new LicenseService();
